module.exports = __webpack_public_path__ + "img/hr-centrifuge-B-light.f8943caf.png";